// Auth client. The relying-party Worker (plan §4) owns the OIDC dance.
// The UI only triggers the login redirect, reads the resulting /me, and logs out.

import type { User } from "@/types";
import { Endpoints, http } from "./http";

export const AuthApi = {
  beginLogin(returnTo?: string): void {
    // Worker generates state + PKCE, stores in D1, 302s to Pocket ID /authorize
    const u = new URL(Endpoints.auth_login, window.location.origin);
    if (returnTo) u.searchParams.set("return_to", returnTo);
    window.location.assign(u.toString());
  },
  me(): Promise<User> { return http<User>(Endpoints.auth_me); },
  logout(): Promise<void> { return http<void>(Endpoints.auth_logout, { method: "POST" }); },
};
